import { AdminCountyData } from '@models/interfaces';

export const STATE_DEFAULT_VALUE: AdminCountyData = {
  id: '',
  name: '',
};
